import React, { useState } from "react";
import PropTypes from "prop-types";
import { useLazyQuery } from "@apollo/react-hooks";
import { Loading } from "components/common";
import SearchBar from "components/common/SearchBar";
import { isKey, USER_TOMO_CREDIT_REPORT } from "utils";
import parseError from "utils/parseError";
import Attributes from "./elements/Attributes";

const Results = ({ attributes }) => {
  if (!attributes.length) {
    return <p>No results found</p>;
  }
  return (
    <div>
      <Attributes attributes={attributes} />
    </div>
  );
};

const CreditDashboardUserSearch = () => {
  const [searchInput, setSearchInput] = useState("");
  const [fetchUserTomoCreditReport, { data, loading, error }] = useLazyQuery(
    USER_TOMO_CREDIT_REPORT,
    {
      fetchPolicy: "network-only",
    },
  );

  const getUserCreditReport = async () => {
    fetchUserTomoCreditReport({
      variables: {
        email: searchInput,
      },
    });
  };

  return (
    <div>
      <div className="my-auto items-center mx-auto justify-center bg-transparent rounded-lg">
        <div className="flex justify-between">
          <h1 className="text-2xl font-normal py-1">
            Credit Reporting Dashboard
          </h1>
        </div>
        <div>
          <SearchBar
            placeholder="Email"
            value={searchInput}
            onChange={({ value }) => {
              setSearchInput(value);
            }}
            onMagnifyIconClick={getUserCreditReport}
            onKeyDown={(e) => {
              if (isKey(e, ["enter"])) {
                getUserCreditReport();
              }
            }}
          />
        </div>
        <div className="mt-2">
          {loading && <Loading />}
          {error && <p>{parseError(error) || "Error retrieving user details"}</p>}
          {data && (
            <Results
              attributes={Object.entries(data.userTomoCreditReport || {})}
            />
          )}
        </div>
      </div>
    </div>
  );
};

Results.propTypes = {
  attributes: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
};

export default CreditDashboardUserSearch;
